import { Box, IconButton, Typography } from '@mui/material'
import { ArrowLeft24Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { AttachmentImageGalleryHeaderActions } from './AttachmentImageGalleryHeaderActions.jsx'
import styles from '../AttachmentImageGallery.module.scss'

export function AttachmentImageGalleryHeader(props) {
  const { senderLabel, resolvedSubtitle, secondaryLine, onClose, ...actions } = props

  return (
    <header className={styles.header}>
      <Box className={styles.headerLeft}>
        <Tooltip text="Back" placement="bottom">
          <IconButton type="button" size="small" className={styles.headerIconBtn} onClick={onClose} aria-label="Close gallery">
            <ArrowLeft24Regular className={styles.headerIcon} aria-hidden />
          </IconButton>
        </Tooltip>
        <Box className={styles.headerTitles}>
          <Typography id="attachment-image-gallery-title" component="div" className={styles.senderName}>
            {senderLabel}
          </Typography>
          <Box className={styles.metaRow}>
            <Typography component="span" className={styles.metaMuted}>
              {resolvedSubtitle}
            </Typography>
            {secondaryLine ? (
              <Typography component="span" className={styles.metaMuted}>
                {secondaryLine}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </Box>
      <AttachmentImageGalleryHeaderActions {...actions} />
    </header>
  )
}
